import { useQuery } from "@/api/swr/useQuery";
import { assessmentSchema } from "@/schema/app/assessment/assessment";

type Config = Parameters<
  typeof useQuery<typeof assessmentSchema>
>[2];

export const useGetAssessment = (config: Config) => {
  return useQuery(assessmentSchema, "/app/assessment", config);
};
